import type { TourStep } from "../types";

/**
 * The tour's sign-off. Element-less, so it always survives the
 * DOM-presence filter and the tour never ends on a dropped step.
 *
 * `sawDetail` is false when the detail leg was dropped because the user
 * can see no suggestions yet — the copy then points at what they missed.
 */
export function closingSteps(sawDetail: boolean): TourStep[] {
  return [
    {
      title: "That's the tour",
      description: sawDetail
        ? "You can restart it any time from the account menu at the bottom of the sidebar — Product Tour sits just under View Workflow."
        : "There were no suggestions to open, so the detail view was skipped. Once the register has one, open it to see the committee evaluations, notes and status history. Restart the tour any time from the account menu — Product Tour sits just under View Workflow.",
    },
  ];
}
